import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "./Signup.css";
import Bg from "../assets/sign-bg.png";

const SOCKET_SERVER_URL = process.env.REACT_APP_BACKEND_URL;
const API_SERVER_URL = `${SOCKET_SERVER_URL}`;

const Signup = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
    inviteCode: "",
  });
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    

    if (formData.password !== formData.confirmPassword) {
      setError("Passwords don’t match. Please try again.");
      return;
    }

    try {
      const response = await fetch(`${API_SERVER_URL}/signup`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: formData.name,
          inviteCode: formData.inviteCode,
          email: formData.email,
          password: formData.password,
        }),
      });

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || "Signup failed");
      }

      setMessage("Signup successful!");
      setTimeout(() => navigate("/login"), 1000);
    } catch (err) {
      setError(err.message || "Signup failed. Please try again.");
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSubmit();
    }
  };

  return (
    <div className="signup-container">
      <img src={Bg} className="signup-left" alt="Signup Background" />
      <div className="signup-right">
        <div className="signup-header">
          <h1>Welcome to LovingIs...</h1>
        </div>

        <form onSubmit={handleSubmit} className="signup-form">
          <label>
            Full Name*
            <div className="input-wrapper">
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={(e) => {
                  const regex = /^[A-Za-z\s]*$/; // Allows only letters and spaces
                  if (regex.test(e.target.value)) {
                    handleChange(e);
                  }
                }}
                required
                
              />
            </div>
          </label>
          <label>
            Email*
            <div className="input-wrapper">
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
          </label>
          <label>
            Password* (Min 8 characters)
            <div className="password-wrapper">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                minLength={8}
                value={formData.password}
                onChange={handleChange}
                required
                className="password-input"
              />
              <span
                className="toggle-password"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEyeSlash color="brown" /> : <FaEye color="brown"/>}
              </span>
            </div>
          </label>
          <label>
            Confirm Password*
            <div className="password-wrapper">
              <input
                type={showConfirmPassword ? "text" : "password"}
                name="confirmPassword"
                minLength={8}
                value={formData.confirmPassword}
                onChange={handleChange}
                required
              />
              <span
                className="toggle-password"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              >
                {showConfirmPassword ? <FaEyeSlash color="brown" /> : <FaEye  color="brown"/>}
              </span>
            </div>
          </label>
          <label>
            Invitation Code*
            <div className="input-wrapper">
              <input
                type="text"
                name="inviteCode"
                value={formData.inviteCode}
                onChange={handleChange}
                required
              />
            </div>
          </label>
          <button type="submit" className="signup-button">
            Sign Up
          </button>
          <div className="join-messages">
            {error && <p style={{ color: "red" }}>{error}</p>}
            {message && <p style={{ color: "green" }}>{message}</p>}
          </div>
        </form>
        <p className="signup-footer">
          Already Have an Account? <Link to="/login">Login</Link>
        </p>
      </div>
    </div>
  );
};

export default Signup;
